import { createFileRoute } from "@tanstack/react-router";

import { parseStatsDebugSearch } from "~/features/player/components/StatsDebugView/statsDebugSearch.ts";
import {
    resolveStatsDebugSelection,
    toStatsDebugSearch,
} from "~/features/player/components/StatsDebugView/statsDebugUtils.ts";
import { StatsDebugView } from "~/features/player/components/StatsDebugView/StatsDebugView.tsx";

const StatsDebugPage = () => {
    const navigate = Route.useNavigate();
    const selection = resolveStatsDebugSelection(Route.useSearch());

    return (
        <StatsDebugView
            {...selection}
            onChange={(change) => {
                navigate({ search: { ...toStatsDebugSearch(selection), ...change }, replace: true });
            }}
        />
    );
};

export const Route = createFileRoute("/_auth/dev/stats/")({
    validateSearch: parseStatsDebugSearch,
    component: StatsDebugPage,
});
